import React from 'react';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const handleScrollDown = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.querySelector('#work');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="top" className="relative min-h-screen flex flex-col justify-center px-6 md:px-12 max-w-7xl mx-auto pt-20" data-id="element-55">
      <div className="max-w-4xl" data-id="element-56">
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-text leading-[1.1] mb-8" data-id="element-57">
          Designing experiences <br className="hidden md:block" data-id="element-58" />
          <span className="text-text-muted italic" data-id="element-59">that matter.</span>
        </h1>
        <p className="font-sans text-lg md:text-xl text-text-muted max-w-2xl leading-relaxed" data-id="element-60">
          I'm Elena, a Senior UX Designer specializing in complex systems,
          enterprise software, and human-centered digital products.
        </p>
      </div>

      <div className="absolute bottom-12 left-6 md:left-12 animate-bounce" data-id="element-61">
        <a href="#work" onClick={handleScrollDown} className="flex items-center justify-center w-12 h-12 rounded-full border border-border text-text-muted hover:text-accent hover:border-accent transition-colors" aria-label="Scroll down to work" data-id="element-62">
          <ArrowDown size={20} data-id="element-63" />
        </a>
      </div>
    </section>;
}